import isFunction from 'lodash/isFunction';

function generateAction(type, ...props) {
  if (!type) {
    throw new Error('ActionTypeMissing');
  }

  return function generateActionType(...args) {
    const action = {
      type,
    };

    for (const name of props) {
      action[name] = args.shift();
    }

    return action;
  };
}

export const ActionHelper = {
  /**
   * Generate action type key/value pairs given a list of types.
   * Given an array like [ 'PENDING_SET' ]
   * Will generate an object like { PENDING_SET: 'PENDING_SET' }
   */
  generateTypes(types = []) {
    const result = {};

    for (const type of types) {
      result[type] = type;
    }

    return result;
  },

  /**
   * Generates Redux actions from functions (already a Readux action) or
   * from an array. When an array is provided in the form of
   * [ ACTION_NAME , 'keyName1', 'keyName2' ] it creates an actions that expects
   * two arguments (keyName1, keyName2) and dispatches an action called ACTION_NAME
   */
  generateActions(actions = {}) {
    const result = {};
    const types = Object.keys(actions);

    for (const type of types) {
      result[type] = isFunction(actions[type])
        ? actions[type]
        : generateAction(...actions[type]);
    }

    return result;
  },
};
